import RequestForm from "../../../../core/model2/form/request-form"
import RequestFormField from "../../../../core/model2/form/settings/field"
import {RequestFormFieldType} from "../const/const"
import {addToFormFields} from "./submit-form"
import DatetimeUtils from "../../../../core/gd/utils/datetime-utils"

export function prepareSubmissionData(
    requestForm     : RequestForm,
    submissionData  : any,
    formFields      : any,
    result          : any
) {

    let fieldNumber = 0
    _.map(requestForm.settings.fields, (requestFormField: RequestFormField, key) => {
        if (!requestFormField.field) return

        let fieldId
        switch (requestFormField.type) {

            case RequestFormFieldType.TASK:
                fieldId         = requestFormField.field?.fieldId
                if (fieldId) {
                    if (requestFormField.field?.isCustom) {
                        if (!submissionData.customFieldsData) submissionData.customFieldsData = []
                        submissionData.customFieldsData.push({
                            id          : fieldId,
                            value       : result[fieldId],
                            valueType   : gd.session.customFields.get(fieldId)!.valueType
                        })
                    } else {
                        switch (fieldId) {
                            case 'startEnd'             :
                                if (result['startEnd']) {
                                    submissionData['planningStartDate'] = DatetimeUtils.momentToDate(result['startEnd'].start)
                                    submissionData['planningEndDate']   = DatetimeUtils.momentToDate(result['startEnd'].end)
                                }
                                break

                            case 'assignedToUserId'     :
                                submissionData['user']              = result['assignedToUserId']
                                submissionData['users']             = [submissionData['user']]
                                break

                            default                     :
                                submissionData[fieldId]             = result[fieldId]
                        }
                    }
                }
                break

            case RequestFormFieldType.FORM:
                fieldId = "f-{0}".f(++fieldNumber)
                addToFormFields(formFields, requestFormField, result[fieldId])
                break
        }
    })
}